<template>
  <section id="kelas-iklim">
    <Header :scrolled="true"/>
    <div class="pageInfo bumiKini">
      <div class="coverImg"></div>
      <div class="pageInfoWrapper">
        <div class="topBg"></div>
        <div class="pageInfoWrapper2">
          <div class="worCnt tenggelamDalamDiam">
            <div>
              <div class="articleContent">
                <p>Sebagai bagian dari rangkaian pameran Mengabarkan Kita Tenggelam,
                  Mini Workshop: Mengemas Pesan Iklim dengan Karya digelar dengan
                  melibatkan peserta-peserta kreatif yang terpilih lewat minat dan karyanya.</p>
                <p>Berasal dari asal daerah yang beragam serta keahlian berkarya dalam
                  bermacam-macam bentuk format, para peserta menunjukkan antusiasme tinggi
                  dalam memahami krisis iklim sekaligus mengembangkan proses kreatif mereka.</p>
                <p>Keberagaman yang terjalin kemudian menghasilkan sejumlah kreasi menarik
                  yang penuh warna, mewakili pesan-pesan penting yang terkemas dalam
                  ekspresi-ekspresi karya berikut:</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="qweCnt">
        <div class="qwe">
          <div class="photoAlbum">
            <div class="photoSc">
              <div class="photoItem photoBig">
                <div class="thePhoto karya1" v-on:click="viewKarya(0)">
                  <div class="hoverBg"></div>
                  <div class="playIcon"></div>
                </div>
              </div>
              <div class="photoItem photoBig">
                <div class="thePhoto karya2" v-on:click="viewKarya(1)">
                  <div class="hoverBg"></div>
                  <div class="playIcon"></div>
                </div>
              </div>
              <div class="photoItem">
                <div class="thePhoto karya3" v-on:click="viewKarya(2)">
                  <div class="hoverBg"></div>
                  <div class="playIcon eye"></div>
                </div>
              </div>
              <div class="photoItem">
                <div class="thePhoto karya4" v-on:click="viewKarya(3)">
                  <div class="hoverBg"></div>
                  <div class="playIcon eye"></div>
                </div>
              </div>
              <div class="photoItem">
                <div class="thePhoto karya5" v-on:click="viewKarya(4)">
                  <div class="hoverBg"></div>
                  <div class="playIcon eye"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="beforeFooter"></div>
    <KaryaViewer ref="karyaViewer"/>
  </section>
</template>

<script>
import { DateTime } from 'luxon';
import Header from '@/components/Header.vue';
import KaryaViewer from '@/components/KaryaViewer.vue';

export default {
  name: 'karya',
  components: { Header, KaryaViewer },
  data() {
    return {
    };
  },
  methods: {
    viewKarya(idx) {
      document.body.classList.add('hideoverflow');
      this.$refs.karyaViewer.open(idx);
    },
  },
  computed: {},
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Karya Palatihan - Mengabarkan Kita Tenggelam - Bumi Butuh Aksi';
  },
};
</script>


<style lang="scss">
  .cdCnt{
    margin-top: -24px;
    p{
      font-size: 24px;
      margin: 0 0 20px;
      @media (max-width: 680px) {
        font-size: 17px;
      }
    }
    .btn{
      margin-top: 20px;
    }
  }
  .tenggelamDalamDiam{
    .loadingContent{
      .l1{
        height: 30px;
        background-color: rgba(0,0,0,.1);
        width: 80%;
        margin-bottom: 10px;
      }
      .l2{
        height: 30px;
        background-color: rgba(0,0,0,.1);
        margin-bottom: 10px;
      }
    }
    .articleContent{
      font-size: 20px;
      line-height: 1.6;
      font-weight: 400;
      blockquote{
        font-size: 26px;
        line-height: 1.3;
        border-left: #ddd 4px solid;
        position: relative;
        margin: 26px 0;
        padding-bottom: 6px;
        color: #767676;
        padding-left: 50px;
        padding-left: 30px;
        &:before{
          content: "\"";
          font-size: 80px;
          position: absolute;
          left: 14px; top: -14px;
          display: none;
        }
      }
      p.caption{
        margin: -14px 0 20px 10px;
        font-size: 15px;
        line-height: 1.4;
        min-height: 22px;
      }

      p{
        margin: 0;
      }
      iframe.theMedia{
        border: none;
      }
      iframe.theMedia:not(.theEmbed){
        height: 420px;
        @media (max-width: 700px){
          height: 200px;
        }
      }
      .theMedia{
        display: block;
        margin: 20px 0;
        width: 100%;
        border-radius: 5px;
        position: relative;
        z-index: 3;
        &.md-wide{
          width: calc(100% + 200px);
          margin: 20px -100px;
          @media (max-width: 974px) {
            width: calc(100% + 100px);
            margin: 20px -50px;
          }
          @media (max-width: 874px) {
            width: calc(100% + 40px);
            margin: 20px -20px;
            border-radius: 0;
          }
        }
      }
    }
    @media (max-width: 700px) {
      .articleContent{
        font-size: 18px;
        line-height: 1.6;
      }
    }
  }
  .cdCnt{
    ul li{
      .digit{
        background-color: rgba(0,0,0,.1);
        padding: 8px 16px;
        border-radius: 5px;
        font-weight: 800;
        font-size: 60px;
        @media (max-width: 680px) {
          font-size: 26px;
          padding: 8px 8px 5px;
        }
      }
      .text{
        font-size: 14px;
        font-weight: 600;
        margin-top: 6px;
        @media (max-width: 680px) {
          font-size: 11px;
          margin-top: 4px;
        }
      }
      &:after{
        top: 14px;
        font-size: 46px;
        right: -15px;
        @media (max-width: 680px) {
          font-size: 30px;
          top: 5px; right: -14px;
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  .btn{
    background: #fff;
    border-radius: 50px;
    color: #444;
    box-shadow: none;
    font-weight: 600;
    padding: 10px 20px;
    font-size: 18px;
    padding-left: 52px;
    position: relative;
    transition: all .4s ease;
    cursor: pointer;
    span{
      position: relative;
      z-index: 2;
    }
    .btnL{
      width: 40px; height: 40px;
      border-radius: 50px;
      background-color: #444;
      position: absolute;
      left: 2px; top: 2px;
      transition: all .3s ease;
      background-image: url(../assets/right-arrow-notail-white.png);
      background-size: 20px auto;
      background-position: 10px 50%;
      background-repeat: no-repeat;
    }
    .btnL2{
      width: 40px; height: 40px;
      border-radius: 50px;
      position: absolute;
      left: 2px; top: 2px;
      transition: all .3s ease;
      background-image: url(../assets/right-arrow-notail-white.png);
      background-size: 20px auto;
      background-position: 10px 50%;
      background-repeat: no-repeat;
    }
    &:hover{
      color: #fff;
      .btnL{
        width: calc(100% - 4px);
      }
      .btnL2{
        left: 14px;
      }
    }
  }

  .qweCnt{
    background-color: #fff;
    position: relative;
    z-index: 3;
  }
  .qwe{
    max-width: 1300px;
    margin: 80px auto 40px;
    padding-bottom: 20px;
    // overflow: hidden;
    position: relative;
    @media (max-width: 1360px) {
      max-width: none;
      margin: 80px 20px 40px;
    }
    @media (max-width: 680px) {
      margin: 60px 20px 20px;
    }
    .photoAlbum{
      max-width: 1200px;
      margin: 0 auto;
      .photoSc{
        display: flex;
        margin: 0 -6px;
        flex-wrap: wrap;
        @media (max-width: 680px) {
          display: block;
        }
      }
      .photoItem{
        width: calc(33.33333% - 12px);
        margin: 0 6px 12px;
        @media (max-width: 680px) {
          width: auto;
        }
        &.photoBig{
          width: calc(50% - 12px);
          @media (max-width: 680px) {
            width: auto;
          }
          .thePhoto{
            height: 560px;
            @media (max-width: 1200px) {
              height: 460px;
            }
            @media (max-width: 960px) {
              height: 280px;
            }
            @media (max-width: 680px) {
              height: 260px;
            }
          }
        }
        .thePhoto{
          background-color: #d2d6d6;
          height: 360px;
          cursor: pointer;
          transition: all .3s ease;
          font-weight: 800;
          font-size: 68px;
          color: #50534c;
          line-height: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          background-size: cover;
          background-position: center;
          position: relative;
          .hoverBg{
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
            background-color: #000;
            opacity: 0;
            transition: all .3s ease;
          }
          .playIcon{
            width: 80px; height: 80px;
            position: absolute;
            top: 50%; left: 50%;
            margin: -40px 0 0 -40px;
            background-image: url(../assets/play-button.png);
            background-position: center;
            background-size: 64px auto;
            background-repeat: no-repeat;
            transition: all .3s ease;
            &.eye{
              background-image: url(../assets/eye-white.png);
              background-size: 34px auto;
              opacity: 0;
            }
          }
          &:hover{
            .hoverBg{
              opacity: .6;
            }
            .playIcon{
              opacity: 1;
            }
          }
          &.karya1{
            background-image: url("../assets/karya/Transisi ke energi terbarukan.jpg");
          }
          &.karya2{
            background-image: url("../assets/karya/Serem Gak_ Seremlah Masa Engga.jpg");
          }
          &.karya3{
            background-image: url("../assets/karya/poster alifro.png");
            background-position: center top;
          }
          &.karya4{
            background-image: url("../assets/karya/Toba - KLP2.jpg");
            background-position: center top;
          }
          &.karya5{
            background-image: url("../assets/karya/hotplate.jpg");
          }
          @media (max-width: 1200px) {
            font-size: 54px;
            height: 300px;
          }
          @media (max-width: 960px) {
            font-size: 38px;
            height: 220px;
          }
          @media (max-width: 680px) {
            height: 260px;
          }
          span{
            display: block;
          }
          &:hover{
            background-color: #bbb;
          }
        }
      }
    }
  }


  .pageInfo{
    // background-image: url(../assets/kelas-iklim.jpg);
    background-size: cover;
    background-position: center;
    position: relative;
    margin-top: 80px;
    padding-top: 60vw;
    @media (max-width: 768px) {
      margin-top: 64px;
      padding-top: 56vw;
    }
    .coverImg{
      width: 100%;
      height: auto;
      margin: 0 auto;
      display: block;
      position: absolute;
      left: 0; top: 0; right: 0;
      background-image: url(../assets/Mengemas-Pesan-Iklim.jpg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: #eee;
      height: 62vw;
      z-index: 1;
    }
    .pageInfoWrapper2{
      overflow: hidden;
    }
    .pageInfoWrapper{
      max-width: none !important;
      background-color: #f4f6f1;
      position: relative;
      z-index: 9;
      margin: 0 auto !important;
      padding: 80px 0;
      @media (max-width: 860px) {
        padding: 40px 0;
      }
      .topBg{
        position: absolute;
        top: -58px; right: 0; left: 0; height: 60px;
        background-image: url(../assets/bg-pale_02.png);
        background-size: 100% auto;
        background-position: bottom center;
        background-repeat: no-repeat;
      }
      .worCnt{
        max-width: 860px;
        margin: 0 auto;
        color: #767676;
        position: relative;
        > ol > li{
          margin-bottom: 40px;
        }
        @media (max-width: 940px) {
          max-width: none;
          margin: 0 20px;
        }
      }
      .mapImg{
        margin-top: 30px;
        img{
          width: 100%; height: auto;
        }
      }
      iframe{
        width: 100%;
        height: 440px;
        @media (max-width: 768px) {
          height: 400px;
        }
        @media (max-width: 680px) {
          height: 180px;
        }
      }
      h2{
        max-width: 800px;
        margin: 0 auto 20px;
        font-size: 46px;
      }
      h4{
        margin: 40px auto 16px;
        font-size: 24px;
        max-width: 800px;
        line-height: 1.5;
      }
      p{
        margin: 0 auto 16px;
        max-width: 800px;
        font-size: 16px;
        line-height: 1.5;
        @media (max-width: 680px) {
          line-height: 1.4;
        }
      }
      a{
        color: #0b9a6b;
        text-decoration: none;
        font-weight: bold;
        &:hover{
          color: #32c1f4;
        }
        &.copy-hashtag{
          display: inline-block;
          padding-right: 30px;
          position: relative;
          // background-color: #eee;
          border-radius: 50px;
          padding-left: 6px;
          &:before{
            content: "";
            display: block;
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            right: 0; top: 0;
            background-image: url(../assets/copy.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #f9f9f9;
            &:before{
              background-image: url(../assets/copy-hover.png);
            }
          }
          &:active{
            background-color: #eee;
          }
        }
        &.ext-link{
          display: inline-block;
          padding-right: 30px;
          position: relative;
          // background-color: #eee;
          border-radius: 50px;
          padding-left: 6px;
          &:before{
            content: "";
            display: block;
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            right: 0; top: 0;
            background-image: url(../assets/external-link.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #f9f9f9;
            &:before{
              background-image: url(../assets/external-link-hover.png);
            }
          }
          &:active{
            background-color: #eee;
          }
        }
      }
      a.btn{
        color: #fff;
        margin-bottom: 20px;
        &:hover{
          color: #fff;
        }
      }
      ol{
        margin: 0;
        padding: 0;
        padding-left: 24px;
        font-size: 20px;
        &.a{
          list-style: lower-alpha;
        }
        li{
          margin: 0 0 10px;
        }
        h5{
          margin: 0 0 10px;
          font-size: 20px;
          font-weight: bold;
          line-height: 1.5;
        }
      }

      @media (max-width: 760px) {
        padding-top: 30px;
        .coverImg{
          margin-top: -30px;
        }
        h2{
          font-size: 50px;
          margin-left: -3px;
        }
        h4{
          font-size: 22px;
        }
      }
      @media (max-width: 680px) {
        h2{
          font-size: 38px;
          line-height: 1.3;
        }
      }
    }
  }

  .beforeFooter{
    height: 100px;
    background-color: #f4f6f1;
    @media (max-width: 680px) {
      height: 60px;
    }
  }
</style>
